/**
 *
 * Capsules
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import _ from 'lodash';
import classNames from 'classnames';
import * as constants from '../common.components.constants';
import ValidationErrorMessage from '../ValidationErrorMessage/ValidationErrorMessage';


class Capsules extends React.Component {
  // eslint-disable-next-line no-undef
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    fluid: PropTypes.bool,
    index: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    prefix: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.array.isRequired,
  };

  state = {
    options: [],
    searchQuery: ''
  };

  componentWillMount() {
    this.setState({ options: this.props.value.map((opt) => ({ text: opt, value: opt })) || [] });
  }

  componentWillReceiveProps(nextProps) {
    // First check if the new elements added and previous elements are same or not
    if (!this.areListsSame(this.props.value, nextProps.value)) {
      const arr = [];
      for (let i = 0; i < nextProps.value.length; i++) {
        arr.push({ text: nextProps.value[i], value: nextProps.value[i] });
      }
      // If the lists are not same, then only create a state change
      this.handleAdditionList(null, arr);
    }
  }

  areListsSame(previousList, newList) {
    return previousList.every(function (element, index) {
      // compare if the element matches in the same index
      return element === newList[index];
    });
  }

  /**
   * Add condition values as a list
   * primarly used when arrow buttons are pressed
   * @param e
   * @param optionsList
   */
  handleAdditionList = (e, optionsList) => {
    if (optionsList.length === 0) {
      return;
    }
    this.setState({ options: optionsList }, () => {
      this.handleChange(e, { value: this.state.options.map((opt) => opt.value), name });
    });
  };

  /**
   * trim added value
   * ignore change if added value is empty
   * insert added value to values array and fire onChange event
   * @param e
   * @param value
   * @param name
   */
  handleAddition = (e, { value, name }) => {
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0) {
      return;
    }
    // We don't want to add an existing condition value. We have to stop the user entering the same value.
    const isConditionValueAlreadyExisting = this.state.options.some(el => el.text === trimmedValue);
    if (!isConditionValueAlreadyExisting) {
      this.setState({ options: [...this.state.options, { text: trimmedValue, value: trimmedValue }] }, () => {
        this.handleChange(e, { value: this.state.options.map((opt) => opt.value), name });
      });
    } else {
      this.setState({ searchQuery: '' });
    }
  };

  /**
   * send component data to model
   * and empty searchQuery in state
   * @param e
   * @param data
   */
  handleChange = (e, data) => {
    this.props.onChange(e, data);
    this.setState({ searchQuery: '' });
  };

  /**
   * add search query value to options array, same as when pressing enter
   * (only if search query is not empty
   * @param e
   * @param data
   */
  handleBlur = (e, data) => {
    if (this.state.searchQuery.length) {
      this.handleAddition(e, { value: this.state.searchQuery, name: data.name });
    }
  };

  /**
   * write searchQuery to state so we can use it on blur
   * @param e
   * @param data
   */
  handleSearchChange = (e, data) => {
    this.setState({ searchQuery: data.searchQuery });
  };

  render() {

    const { formatMessage } = this.props.intl; // eslint-disable-line react/prop-types

    // noinspection JSUnusedLocalSymbols
    const { error, index, intl, prefix, type, ...props } = this.props; // eslint-disable-line react/prop-types
    const errorMessage = error ? formatMessage({ id: error }) : '';
    const dropDownClassName = classNames(this.props.className, { capsules: true, inputFieldError: !_.isNil(error) });

    return (
      <div className="dropdown-wrapper">
        <Dropdown
          {...props}
          allowAdditions
          className={dropDownClassName}
          data-automation-id={prefix}
          multiple
          name={this.props.name}
          onAddItem={this.handleAddition}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onSearchChange={this.handleSearchChange}
          options={this.state.options}
          placeholder={formatMessage({ id: 'activity.condition.conditionValue.placeholder.arrayExplanation' })}
          selection
          search
        />
        {error ? (<ValidationErrorMessage
          errorMessage={errorMessage}
          dataAutomationId={`${prefix}.error.message`}
        />) : null}
      </div>
    );
  }
}

export default injectIntl(Capsules);
